var _react_refresh_temp_1, _react_refresh_temp_2, _react_refresh_temp_3;
var _react_refresh_temp_4;
_react_refresh_temp_4 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import { createSelector } from '@reduxjs/toolkit';
import { useAppSelector } from '../../store';
const isActiveSelector = createSelector(_react_refresh_temp_1 = (state) => {
    var _a;
    return (_a = state.session.currentRoom.metadata) === null || _a === void 0 ? void 0 : _a.room_features.display_external_link_features;
}, (display_external_link_features) => display_external_link_features === null || display_external_link_features === void 0 ? void 0 : display_external_link_features.is_active);
$RefreshReg$(_react_refresh_temp_1, "isActiveSelector$createSelector");
const linkSelector = createSelector(_react_refresh_temp_2 = (state) => {
    var _a;
    return (_a = state.session.currentRoom.metadata) === null || _a === void 0 ? void 0 : _a.room_features.display_external_link_features;
}, (display_external_link_features) => display_external_link_features === null || display_external_link_features === void 0 ? void 0 : display_external_link_features.link);
$RefreshReg$(_react_refresh_temp_2, "linkSelector$createSelector");
const DisplayExternalLink = () => {
    _react_refresh_temp_4();
    const link = useAppSelector(linkSelector);
    const isActive = useAppSelector(isActiveSelector);
    const [loaded, setLoaded] = useState();
    const onLoad = () => {
        setLoaded(true);
    };
    const render = () => {
        if (!link || link === '') {
            return null;
        }
        return (_jsxs("div", { className: "external-display-link-wrapper m-auto h-[calc(100%-50px)] w-full max-w-[1100px] flex-1 sm:px-5 mt-9 p-2", children: [!loaded ? (_jsx("div", { className: "loading absolute left-[50%] top-[40%] flex justify-center", children: _jsxs("div", { className: "lds-ripple", children: [_jsx("div", { className: "border-secondaryColor" }), _jsx("div", { className: "border-secondaryColor" })] }) })) : null, _jsx("iframe", { height: "100%", width: "100%", src: link, onLoad: onLoad })] }));
    };
    return _jsx(_Fragment, { children: isActive ? render() : null });
};
_react_refresh_temp_3 = DisplayExternalLink;
$RefreshReg$(_react_refresh_temp_3, "DisplayExternalLink");
_react_refresh_temp_4(DisplayExternalLink, "kE5DrxoHs5VI516oBAo8Jkt1Egg=", false, () => [useAppSelector, useAppSelector]);
export default DisplayExternalLink;
